import { render, staticRenderFns } from "./contentful.vue?vue&type=template&id=58a2159f&scoped=true&"
import script from "./contentful.vue?vue&type=script&lang=js&"
export * from "./contentful.vue?vue&type=script&lang=js&"
import style0 from "./contentful.vue?vue&type=style&index=0&id=58a2159f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a2159f",
  null
  
)

export default component.exports